import { ApplicationFlowTheme } from '../types'
import { getApplicationFlowTheme } from './application-flow-theme'

interface ResultChannelPresentationConfig {

  /** 结果皮肤版本与主题的唯一选择依据。 */
  channelTemplate?: unknown
}

export interface ResultPresentation {

  /** 由渠道模板解析出的结果页主题。 */
  theme: ApplicationFlowTheme
}

/**
 * resolveResultPresentation — 将旧容器已获取的渠道详情映射为结果展示配置。
 * 非 v2 模板返回 null，确保结果类型、设备和下载策略均不会参与皮肤选择。
 * @param {unknown} detail 旧结果容器请求到的渠道详情
 * @returns {ResultPresentation | null} 有效的 v2 结果主题，或继续使用旧展示的 null
 */
export const resolveResultPresentation = (detail: unknown): ResultPresentation | null => {
  const config = detail && typeof detail === 'object' ? detail as ResultChannelPresentationConfig : null
  const theme = getApplicationFlowTheme(config?.channelTemplate)

  return theme ? { theme } : null
}
